<div class="grid align-items-center mb-2" data-cy="my-follow-ups">
	<div class="col-6">
		Select follow-ups to complete
	</div>
	<div class="col-6 text-right">
		<button
			(click)="completeSelectedFollowUps()"
			[style]="{ 'max-width': '180px' }"
			class="p-button-primary"
			icon="pi pi-check"
			label="Complete Selected"
			pButton
		></button>
	</div>
</div>

<div class="custom-card">
	<div *ngIf="isLoading" class="text-center py-4">Loading...</div>
	<div *ngIf="isCompleting" class="text-center py-4">Wait...</div>
	<p-table
		data-cy="my-follow-up-table"
		[(selection)]="selectedFollowUps"
		[paginator]="true"
		[rows]="20"
		[style]="{ 'font-size': '12px' }"
		[value]="followUps"
		dataKey="id"
		selectionMode="multiple"
		showCurrentPageReport="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
	>
		<ng-template pTemplate="header">
			<tr>
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="createdDate">Created Date
					<p-sortIcon field="createdDate"></p-sortIcon>
				</th>
				<th pSortableColumn="workflowName">Task Name
					<p-sortIcon field="workflowName"></p-sortIcon>
				</th>
				<th pSortableColumn="followUpDate">Due Date
					<p-sortIcon field="followUpDate"></p-sortIcon>
				</th>
				<th>Action</th>
			</tr>
		</ng-template>

		<ng-template let-followUp pTemplate="body">
			<tr>
				<td>
					<p-tableCheckbox [value]="followUp"></p-tableCheckbox>
				</td>
				<td>{{ followUp.createdDate |  DatePropertyTimezone: false : true }}</td>
				<td>{{ followUp.workflowName }}</td>
				<td>{{ followUp.followUpDate |  DatePropertyTimezone: false : true }}</td>
				<td class="text-center" title="click on the arrow to go to task">
					<a (click)="goToTask(followUp, $event)" title="go to task">
						<i class="pi pi-arrow-right"></i>
					</a>
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="5">No records found</td>
			</tr>
		</ng-template>
	</p-table>
</div>
